import React from 'react';
import { BellRing, Calendar } from 'lucide-react';

import { NotificationFrequency } from '@/api/fe-api/domain/entities/alert-notifications';
import { AlertStatus } from '@/entities/alert-status';

export const labelsFrequency: Record<NotificationFrequency, string> = {
  [NotificationFrequency.Daily]: 'Daily report',
  [NotificationFrequency.NewAlerts]: 'Only on new alerts',
};

export const iconsFrequency: Record<
  NotificationFrequency,
  React.ComponentType<{ className?: string }>
> = {
  [NotificationFrequency.Daily]: Calendar,
  [NotificationFrequency.NewAlerts]: BellRing,
};

export const alertStatusTierList: AlertStatus[] = [
  AlertStatus.OK,
  AlertStatus.INFO,
  AlertStatus.WARNING,
  AlertStatus.CRITICAL,
];
